var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	406: () => (loadStrictSingletonVersion("default", "react", false, [4,19,2,0], () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(4041))))))),
	7778: () => (loadStrictSingletonVersion("default", "react-dom", false, [4,19,2,0], () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(3144))))))),
	773: () => (loadStrictSingletonVersion("default", "lodash", false, [4,4,18,1], () => (__webpack_require__.e(5250).then(() => (() => (__webpack_require__(5250))))))),
	6850: () => (loadStrictSingletonVersion("default", "react-i18next", false, [4,15,4,0], () => (__webpack_require__.e(7434).then(() => (() => (__webpack_require__(7434))))))),
	7473: () => (loadStrictSingletonVersion("default", "styled-components", false, [4,6,1,19], () => (__webpack_require__.e(3864).then(() => (() => (__webpack_require__(3864))))))),
	8025: () => (loadStrictSingletonVersion("default", "qwep-kit", false, [4,0,3,7], () => (__webpack_require__.e(8662).then(() => (() => (__webpack_require__(8662))))))),
	8656: () => (loadStrictSingletonVersion("default", "@tanstack/react-query", false, [4,5,64,2], () => (__webpack_require__.e(5287).then(() => (() => (__webpack_require__(5287))))))),
	9269: () => (loadStrictSingletonVersion("default", "react-router", false, [4,7,12,0], () => (__webpack_require__.e(4269).then(() => (() => (__webpack_require__(4269))))))),
	426: () => (loadStrictSingletonVersion("default", "effector", false, [4,23,4,4], () => (__webpack_require__.e(1810).then(() => (() => (__webpack_require__(1810))))))),
	445: () => (loadStrictVersion("default", "@package/general", false, [0], () => (Promise.all([__webpack_require__.e(7304), __webpack_require__.e(3016), __webpack_require__.e(4212), __webpack_require__.e(3499), __webpack_require__.e(3463), __webpack_require__.e(7596), __webpack_require__.e(8710), __webpack_require__.e(9340), __webpack_require__.e(1857), __webpack_require__.e(2275)]).then(() => (() => (__webpack_require__(2275))))))),
	973: () => (loadStrictSingletonVersion("default", "effector-react", false, [4,23,3,0], () => (Promise.all([__webpack_require__.e(1810), __webpack_require__.e(93)]).then(() => (() => (__webpack_require__(2474))))))),
	3889: () => (loadStrictSingletonVersion("default", "socket.io-client", false, [4,4,7,5], () => (__webpack_require__.e(254).then(() => (() => (__webpack_require__(254))))))),
	4974: () => (loadStrictSingletonVersion("default", "effector-action", false, [4,1,2,2], () => (__webpack_require__.e(3516).then(() => (() => (__webpack_require__(1135))))))),
	3463: () => (loadStrictSingletonVersion("default", "@dnd-kit/utilities", false, [4,3,2,2], () => (Promise.all([__webpack_require__.e(406), __webpack_require__.e(6550)]).then(() => (() => (__webpack_require__(6550))))))),
	1857: () => (loadStrictSingletonVersion("default", "@dnd-kit/core", false, [4,6,3,1], () => (Promise.all([__webpack_require__.e(1380), __webpack_require__.e(7778)]).then(() => (() => (__webpack_require__(1380))))))),
	2178: () => (loadStrictSingletonVersion("default", "@opentelemetry/semantic-conventions", false, [4,1,28,0], () => (__webpack_require__.e(1705).then(() => (() => (__webpack_require__(1705))))))),
	7931: () => (loadStrictSingletonVersion("default", "@opentelemetry/api", false, [4,1,9,0], () => (__webpack_require__.e(8440).then(() => (() => (__webpack_require__(8440))))))),
	9340: () => (loadStrictSingletonVersion("default", "@opentelemetry/resources", false, [4,1,30,1], () => (__webpack_require__.e(9796).then(() => (() => (__webpack_require__(9796))))))),
	2524: () => (loadStrictSingletonVersion("default", "formik", false, [4,2,4,6], () => (__webpack_require__.e(1096).then(() => (() => (__webpack_require__(1096))))))),
	3107: () => (loadStrictSingletonVersion("default", "yup", false, [4,1,6,1], () => (__webpack_require__.e(9313).then(() => (() => (__webpack_require__(9313))))))),
	3499: () => (loadStrictSingletonVersion("default", "lucide-react", false, [4,1,28,0], () => (__webpack_require__.e(7700).then(() => (() => (__webpack_require__(7700))))))),
	8710: () => (loadStrictSingletonVersion("default", "clsx", false, [4,2,1,1], () => (__webpack_require__.e(4357).then(() => (() => (__webpack_require__(4357))))))),
	1750: () => (loadStrictSingletonVersion("default", "tabulator-tables", false, [4,6,3,1], () => (__webpack_require__.e(2167).then(() => (() => (__webpack_require__(2167))))))),
	2641: () => (loadStrictSingletonVersion("default", "react-day-picker", false, [4,9,14,0], () => (__webpack_require__.e(4805).then(() => (() => (__webpack_require__(7186))))))),
	2817: () => (loadStrictSingletonVersion("default", "sonner", false, [4,2,0,7], () => (__webpack_require__.e(1582).then(() => (() => (__webpack_require__(1582))))))),
	3076: () => (loadStrictSingletonVersion("default", "@opentelemetry/sdk-trace-web", false, [4,1,30,1], () => (__webpack_require__.e(5632).then(() => (() => (__webpack_require__(5632))))))),
	4492: () => (loadStrictSingletonVersion("default", "dexie", false, [4,4,0,11], () => (__webpack_require__.e(7396).then(() => (() => (__webpack_require__(7396))))))),
	5072: () => (loadStrictSingletonVersion("default", "tailwind-merge", false, [4,3,6,0], () => (__webpack_require__.e(9073).then(() => (() => (__webpack_require__(9073))))))),
	5556: () => (loadStrictSingletonVersion("default", "class-variance-authority", false, [4,0,7,1], () => (__webpack_require__.e(8080).then(() => (() => (__webpack_require__(5699))))))),
	7071: () => (loadStrictSingletonVersion("default", "@dnd-kit/modifiers", false, [4,9,0,0], () => (__webpack_require__.e(3033).then(() => (() => (__webpack_require__(5414))))))),
	8818: () => (loadStrictSingletonVersion("default", "react-hook-form", false, [4,7,80,0], () => (__webpack_require__.e(824).then(() => (() => (__webpack_require__(824))))))),
	9785: () => (loadStrictSingletonVersion("default", "react-window", false, [4,1,8,11], () => (__webpack_require__.e(7376).then(() => (() => (__webpack_require__(7376))))))),
	9937: () => (loadStrictSingletonVersion("default", "@dnd-kit/sortable", false, [4,10,0,0], () => (__webpack_require__.e(7046).then(() => (() => (__webpack_require__(7046)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"406": [
		406
	],
	"426": [
		426
	],
	"1650": [
		445,
		973,
		3889,
		4974
	],
	"1857": [
		1857
	],
	"2275": [
		1750,
		2641,
		2817,
		3076,
		4492,
		5072,
		5556,
		7071,
		8818,
		9785,
		9937
	],
	"3463": [
		3463
	],
	"3499": [
		3499
	],
	"4212": [
		2524,
		3107
	],
	"7596": [
		2178,
		7931
	],
	"7778": [
		7778
	],
	"8308": [
		773,
		6850,
		7473,
		8025,
		8656,
		9269
	],
	"8710": [
		8710
	],
	"9340": [
		9340
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}